import React, { useState, useRef, useEffect } from "react";


import { SelectWrapper, SelectCurrent, SelectImage, SelectListWrapper, SelectListItem } from './chainSelect.styles'

import { useWalletContext } from 'providers/WalletProvider'


interface PropsSelect {
    options: string[];
    onChange: (e: string) => void;
    value: string;
    small: boolean;
    dropUp: boolean;
    enabled: boolean;
    buySelect?: boolean;
}

export const Select = ({ options, onChange, value, small, dropUp = false, enabled = false, buySelect = false }: PropsSelect): React.ReactElement => {
    const node = useRef<HTMLInputElement>();

    const [open, setOpen] = useState(false);

    const state = useWalletContext()
    const {
        changeNetwork,
        provider,
        targetNetwork,
        ethBridgeNetwork,
        chainId,
    } = state


    const handleChange = async (selected: string) => {

        if (selected == 'FTM' && value != 'FTM') {
            if (changeNetwork) await changeNetwork(provider, targetNetwork.chainParams)
            if (chainId == `0x${Number(targetNetwork.chainParams.chainId).toString(16)}`) onChange(selected);
        }
        else if (selected == 'ETH' && value != 'ETH') {
            if (changeNetwork) await changeNetwork(provider, ethBridgeNetwork.chainParams)
            if (chainId == `0x${Number(ethBridgeNetwork.chainParams.chainId).toString(16)}`) onChange(selected);
        }
        setOpen(false);
    };

    useEffect(() => {

        if (chainId) {
            if (chainId == '0x1') onChange('ETH');
            else onChange('FTM');
        }
    }, [chainId, onChange]);

    return (
        <SelectWrapper ref={node} open={open} small={small} dropUp={dropUp} enabled={enabled} buySelect={buySelect} eth={chainId === '0x1'} >
            <SelectCurrent open={open} small={small} enabled={enabled} onClick={() => { if (enabled) setOpen(!open) }}>
                <SelectImage src={`${value}.png`} small={small} /> {value}
            </SelectCurrent>

            {
                <SelectListWrapper dropUp={dropUp} small={small} open={open}>
                    {open &&
                        options
                            .filter(opt => opt !== value)
                            .map((opt, index, arr) => (
                                <SelectListItem
                                    key={`select-item-${index}`}
                                    small={small}
                                    last={index === arr.length - 1}
                                    onClick={() => handleChange(opt)}
                                >
                                    <SelectImage src={`${opt}.png`} small={small} /> {opt} 
                                </SelectListItem>
                            ))}
                </SelectListWrapper>
            }
        </SelectWrapper>
    );
};
